import { Button, Layout, theme, Form, Input, Spin, notification } from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import TextArea from "antd/es/input/TextArea";
import StorageSuggestionApi from "../../common/Apis/StorageSuggestionApi";

const AddStorageList = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      name: data?.name,
      description: data?.description,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })

    StorageSuggestionApi.CreateStorage(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/storage-suggestions");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={13}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Description",
                      },
                    ]}
                  >
                    <TextArea
                      placeholder="Description"
                      className="form-control control-input p-3"
                      rows={3}
                      style={{ resize: "none" }}
                    ></TextArea>
                  </Form.Item>
                </Col>


              </Row>

              {/* <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div> */}
              {/* ; */}

              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};
export default AddStorageList;
